import { __assign, __awaiter, __decorate, __generator, __metadata, __param } from "tslib";
import { dataFieldNamingHandler, exceptionHandler, } from '../../../base/decorators';
import { INetworkRequestService } from '../../../base/request/network-request.interface';
import { getFormDataWithParams } from '../../../base/utils';
import { COMMON_COOKIES_KEYS, getCookieByCommonKey } from '@tencent/ark-utils/lib/cookie';
import { camelKeys } from '@tencent/ark-utils/lib/object';
import { addURLParameters } from '@tencent/ark-utils/lib/url';
import { wdocsUserCenter } from '@tencent/wdocs-user-center';
import { ENTERPRISE_DOC_INFO, SET_USER_NICK_AND_AVATAR_CGI, USER_INFO_CGI } from './cgi-path';
var UserInfoRepository = /** @class */ (function () {
    function UserInfoRepository(networkRequestService) {
        this.networkRequestService = networkRequestService;
    }
    UserInfoRepository.prototype.getPersonalUserInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var cookieXsrf, url;
            return __generator(this, function (_a) {
                cookieXsrf = getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf);
                url = "".concat(USER_INFO_CGI, "?xsrf=").concat(cookieXsrf, "&get_vip_info=1");
                return [2 /*return*/, this.networkRequestService.instance.get(url)];
            });
        });
    };
    UserInfoRepository.prototype.updatePersonalNicknameAndAvatar = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var nick, avatar, formData;
            return __generator(this, function (_a) {
                nick = params.nick, avatar = params.avatar;
                formData = getFormDataWithParams({ nick: nick, avatar: avatar });
                return [2 /*return*/, this.networkRequestService.instance.post(SET_USER_NICK_AND_AVATAR_CGI, formData)];
            });
        });
    };
    UserInfoRepository.prototype.getEnterpriseUserInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var userInfo;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, wdocsUserCenter.getUserInfo()];
                    case 1:
                        userInfo = _a.sent();
                        return [2 /*return*/, camelKeys(userInfo)];
                }
            });
        });
    };
    UserInfoRepository.prototype.getEnterpriseDocInfo = function (forceUpdate) {
        return __awaiter(this, void 0, void 0, function () {
            var url, p;
            return __generator(this, function (_a) {
                if (!this.enterpriseDocInfoPromise || forceUpdate) {
                    url = addURLParameters(ENTERPRISE_DOC_INFO, {
                        xrsf: "".concat(getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf)),
                        func: 4,
                    });
                    p = this.networkRequestService.instance.get(url).then(function (result) { return (__assign(__assign({}, result), { data: __assign(__assign({}, result.data), { retcode: result.data.head.ret, msg: result.data.head.msg }) })); });
                    this.enterpriseDocInfoPromise = p;
                }
                return [2 /*return*/, this.enterpriseDocInfoPromise];
            });
        });
    };
    __decorate([
        dataFieldNamingHandler(),
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], UserInfoRepository.prototype, "getPersonalUserInfo", null);
    __decorate([
        dataFieldNamingHandler(),
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], UserInfoRepository.prototype, "updatePersonalNicknameAndAvatar", null);
    __decorate([
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", Promise)
    ], UserInfoRepository.prototype, "getEnterpriseDocInfo", null);
    UserInfoRepository = __decorate([
        __param(0, INetworkRequestService),
        __metadata("design:paramtypes", [Object])
    ], UserInfoRepository);
    return UserInfoRepository;
}());
export default UserInfoRepository;
